import { useMutation } from '@tanstack/react-query';

import { useSupabase } from './use-supabase';

interface Credentials {
  email: string;
  password: string;
  emailRedirectTo: string;
  captchaToken?: string;
  /**
   * Optional user metadata captured at signup. Used to tag which brand
   * (flow / ballee) the user first signed up from — see
   * apps/web/lib/brand.ts. Read back later as
   * `user.user_metadata.signup_brand` for analytics / brand-aware
   * onboarding decisions.
   */
  data?: Record<string, unknown>;
}

export function useSignUpWithEmailAndPassword() {
  const client = useSupabase();
  const mutationKey = ['auth', 'sign-up-with-email-password'];

  const mutationFn = async (params: Credentials) => {
    const { emailRedirectTo, captchaToken, data, ...credentials } = params;

    const response = await client.auth.signUp({
      ...credentials,
      options: {
        emailRedirectTo,
        captchaToken,
        ...(data ? { data } : {}),
      },
    });

    if (response.error) {
      throw response.error;
    }

    return response.data;
  };

  return useMutation({
    mutationKey,
    mutationFn,
  });
}
